module.exports = __webpack_public_path__ + "img/fritar.6a91794e.svg";